import { find, get, isNil, map } from 'lodash';
import { createSelector } from 'reselect';
import { toSuggestion } from './util';
import { allDoctorsSelector } from '../selectors';

const toDiagnosis = (diagnosis, doctors) => ({
  custom: diagnosis.custom,
  displayName: get(diagnosis, 'icd10Code.description') || diagnosis.custom,
  id: diagnosis.id,
  treatingDoctor: find(doctors, { id: diagnosis.treatingDoctorId }),
  treatingDoctorId: diagnosis.treatingDoctorId,
  icd10Code: toSuggestion(diagnosis.icd10Code),
  isSearchResult: !isNil(diagnosis.icd10Code),
  tempId: diagnosis.tempId,
  notes: diagnosis.notes,
});

export const diagnosesSliceSelector = state => get(state, ['dal', 'diagnoses']);

export const diagnosisSelector = createSelector(
  [diagnosesSliceSelector, allDoctorsSelector],
  (diagnoses, doctors) =>
    map(diagnoses, diagnosis => toDiagnosis(diagnosis, doctors)),
);



// WEBPACK FOOTER //
// ./src/lib/dataLayer/diagnoses/selectors.js